export default "__VITE_ASSET__BvsV_koI__"